import React from 'react'
import { IMAGES } from '../../../assets/images'

import { useState } from 'react';

const Accordion = (props) => {
    const [height, setHeight] = useState(0);

    return (
        <>
            <div className="flex bg-white border-b border-[#92929a] p-3 cursor-pointer">
                <div className="w-[10%]">
                    <p className="text-[#92929a] font-bold text-center text-4xl">
                        {props.id}
                    </p>
                </div>
                <div className="w-[80%]">
                    <p
                        className="font-bold text-xl"
                        onClick={() => props.click()}
                    >
                        {props.question}
                    </p>
                    <div
                        className={`overflow-hidden transition-all duration-300`}
                        style={{ height: props.is_open ? `${height}px` : '0px' }}
                        ref={(el) => {
                            if (el && props.is_open) {
                                setHeight(el.scrollHeight);
                            }
                        }}
                    >
                        <p className="text-md">{props.answer}</p>
                    </div>
                </div>
                <div className="w-[10%] text-center">
                    {props.is_open ? (
                        <img
                            src={IMAGES.xmark}
                            alt=""
                            className="m-auto"
                            onClick={props.click}
                        />
                    ) : (
                        <img
                            src={IMAGES.plus}
                            alt=""
                            className="m-auto"
                            onClick={props.click}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default Accordion;
